import React, { useEffect, useMemo } from 'react'
import cx from 'classnames'
import { ButtonSetting } from '../../types/ButtonSetting'
import ConfiguratorIcon from './ConfiguratorIcon'
import styles from './ConfiguratorButton.module.css'
import Loader from '../Loader'
import { StoredIndividualization } from '../../types/Individualization'
import CustomizerPopup from '../../compositions/CustomizerPopup/CustomizerPopup'
import { useFetchSingle } from '../../hooks/useFetchSingle'
import { CustomizerContextProvider } from '../../contexts/CustomizerContext'
import { getTranslatedObject } from '../../helpers/getTranslatedObject'
import { ApiRoutes } from '../../services/ApiService'
import { openModal } from '../../services/ModalService'
import { usePluginContext } from '../../contexts/PluginContext'

const ConfiguratorButton: React.FC = () => {
    const { plugin } = usePluginContext()

    const individualizationId = useMemo(() => {
        const wrapper = document.getElementById('zr-customizer-wrapper')
        return wrapper && wrapper.dataset.individualization
            ? Number(wrapper.dataset.individualization)
            : undefined
    }, [])

    const kArtikel = useMemo(() => {
        const wrapper = document.getElementById('zr-customizer-wrapper')
        return wrapper && wrapper.dataset.article
            ? Number(wrapper.dataset.article)
            : undefined
    }, [])

    const { data: individualization, fetch } =
        useFetchSingle<StoredIndividualization>(ApiRoutes.INDIVIDUALIZATIONS)

    const { data: buttonSetting, fetch: fetchButton } =
        useFetchSingle<ButtonSetting>(ApiRoutes.BUTTON_SETTINGS)

    const showCustomizer = () => {
        if (individualization)
            openModal({
                content: (
                    <CustomizerContextProvider
                        individualization={individualization}
                        kArtikel={kArtikel}
                    >
                        <CustomizerPopup />
                    </CustomizerContextProvider>
                ),
                size: 'lg',
            })
    }

    useEffect(() => {
        fetchButton()
    }, [fetchButton])

    useEffect(() => {
        fetch(individualizationId)
    }, [fetch, individualizationId])

    const translatedButtonSetting = useMemo(() => {
        if (buttonSetting)
            return getTranslatedObject(buttonSetting, plugin?.language)
    }, [buttonSetting, plugin])

    return (
        <button
            type="button"
            onClick={showCustomizer}
            className={cx(
                buttonSetting?.classes,
                'btn',
                'btn-block',
                styles['zr-configurator-button']
            )}
            style={{
                backgroundColor:
                    buttonSetting?.background_color ?? 'transparent',
                color: buttonSetting?.text_color ?? 'transparent',
            }}
        >
            {individualization && translatedButtonSetting ? (
                <>
                    <ConfiguratorIcon
                        fill={translatedButtonSetting.icon_color}
                    />{' '}
                    {translatedButtonSetting.text}
                </>
            ) : (
                <Loader size="s" isLoading={true} />
            )}
        </button>
    )
}

export default ConfiguratorButton
